import { Component, Host, h, Element } from "@stencil/core";

import { hasSlot } from "../../../utils/utils";

/**
 * @slot anchornav - Slot for anchornav
 * @slot aside-left - Slot for aside left content
 * @slot - Slot for content
 */
@Component({
  tag: "stzh-pagecontent",
  styleUrl: "stzh-pagecontent.scss",
  scoped: true,
})
export class StzhPagecontent {
  @Element() element: HTMLStzhPagecontentElement;

  render() {
    const hasAsideLeft = hasSlot(this.element, "aside-left");
    const hasAnchornav = hasSlot(this.element, "anchornav");

    const classes = {
      "stzh-pagecontent": true,
      "stzh-pagecontent--has-aside-left": hasAsideLeft || hasAnchornav,
      "stzh-pagecontent--has-no-aside-left": !hasAsideLeft && !hasAnchornav,
    };

    return (
      <Host>
        <div class={classes}>
          <aside class="stzh-pagecontent__aside-left">
            <div class="stzh-pagecontent__anchornav">
              <slot name="anchornav"></slot>
            </div>
            <slot name="aside-left"></slot>
          </aside>
          <div class="stzh-pagecontent__content">
            <slot></slot>
          </div>
        </div>
      </Host>
    );
  }
}
